import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=185bab4e&lang=pug&"
import script from "./BasePicture.vue?vue&type=script&lang=js&"
export * from "./BasePicture.vue?vue&type=script&lang=js&"
import style0 from "./BasePicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports